const extractKeys = (obj, ...keys) => {
  if (!obj || !keys?.length) return null

  const fn = keys.join('').includes(':')
    ? (o, k) => {
      const [key, alias] = k.split(':')
      const val = obj[key]

      return val === undefined ? o : {
        ...o,
        [alias || key]: val
      }
    }
    : (o, k) => {
      const val = obj[k]

      return val === undefined ? o : {
        ...o,
        [k]: val
      }
    }

  return keys.reduce(fn, {})
}

export const listKeys = (obj, ...keys) => {
  if (!obj || !keys || !keys.length) return null

  const fn = (o, k) => [...o, obj[k]]

  return keys.reduce(fn, [])
}

export const withoutKeys = (obj, ...keys) => {
  if (!obj || !keys || !keys.length) return null

  const fn = (o, k) => {
    delete o[k]
    return o
  }

  return keys.reduce(fn, { ...obj })
}

export default extractKeys;